/*!
 * Stimpack Debug
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

(function($){

    setTimeout(function() {

        $('#sp-debug-panel').each(function() {

            var root = $(this),
                collapseButton = root.find('.sp-debug-panel-collapse-button');

            collapseButton.on('click', function(e) {
                e.preventDefault();
                root.toggleClass('active');
            });
        });

    }, 1500);

})(jQuery);
